import { UUID } from 'crypto'

const serverURL = import.meta.env.VITE_API_URL

export interface EmailPreferences {
  newsletter_subscribed: boolean
  helpful_tips_subscribed: boolean
  opp_notifications_subscribed: boolean
}

export interface EmailPreferencesUpdate {
  newsletter_subscribed?: boolean
  helpful_tips_subscribed?: boolean
  opp_notifications_subscribed?: boolean
}

interface GetEmailPreferencesFn {
  user_uuid: UUID
  token: string
}

export async function getEmailPreferences({
  user_uuid,
  token,
}: GetEmailPreferencesFn): Promise<EmailPreferences> {
  const response = await fetch(
    `${serverURL}/users/${user_uuid}/email-preferences`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}

interface GetOrgOppSettingFn {
  user_uuid: UUID
  org_uuid: UUID
  token: string
}

export async function getOrgOppNotificationSetting({
  user_uuid,
  org_uuid,
  token,
}: GetOrgOppSettingFn): Promise<boolean> {
  const response = await fetch(
    `${serverURL}/users/${user_uuid}/orgs/${org_uuid}/opp-notifications-subscribed`,
    {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    },
  )

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const data = await response.json()
  return data.opp_notifications_subscribed
}

export async function updateOrgOppNotificationSetting({
  user_uuid,
  org_uuid,
  token,
  subscribed,
}: GetOrgOppSettingFn & { subscribed: boolean }): Promise<boolean> {
  const response = await fetch(
    `${serverURL}/users/${user_uuid}/orgs/${org_uuid}/opp-notifications-subscribed`,
    {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ opp_notifications_subscribed: subscribed }),
    },
  )

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const data = await response.json()
  return data.opp_notifications_subscribed
}

interface UpdateEmailPreferencesFn {
  user_uuid: UUID
  token: string
  preferences: EmailPreferencesUpdate
}

export async function updateEmailPreferences({
  user_uuid,
  token,
  preferences,
}: UpdateEmailPreferencesFn): Promise<EmailPreferences> {
  const response = await fetch(
    `${serverURL}/users/${user_uuid}/email-preferences`,
    {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(preferences),
    },
  )

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}
